









































import { Component, Vue } from 'vue-property-decorator';
import UploadFile from "@/components/common/UploadFile.vue";
import UploadType from "@/utils/FileUploadType";
import {FileService} from "@/services/FileService";
import {get} from "@/context/context";
import API from "@/utils/Api";
import {Servers} from "@/serverConfig";

@Component({
  components: {
    UploadFile

  },
})
export default class Uploader extends Vue {
  private fileService: FileService = get('fileService');
  private api: API = get('api');
  private UploadType = UploadType;
  private filesList:Array<any> = [];

  private async saveFiles(files: Array<File>) {
    files.forEach(file => {
      this.filesList.push({name: file.name, file, isTryUpload: false, isUploaded: false, isProcess: true})
    });
    await this.uploadFiles();
  }

  private async uploadFiles() {
    let files = [];
    for (const index in this.filesList) {
      const numIndex = Number(index);
      try{
        if (!this.filesList[numIndex].isTryUpload) {
          this.filesList[numIndex].isTryUpload = true;
          this.api.changeServer(Servers.TEST);
          if ( ((numIndex > 0) && (numIndex % 5) == 0) || numIndex == (this.filesList.length - 1)) {
            if (numIndex == (this.filesList.length - 1) || (numIndex % 5) == 0) {
              files.push(this.filesList[numIndex].file);
            }
            const fileData = await this.fileService.uploadMultiAudio(files);
              if (fileData) {
                const tempFiles = files;
                files = [];
                for (const i in fileData) {
                  const uploadedIndex = tempFiles.findIndex(el => el.name === fileData[i].name+'.wav')
                  const j = (numIndex-(fileData.length-(Number(uploadedIndex)+1)));
                  this.filesList[j].isProcess = false;
                  if (fileData[i].statusCode === 201) {
                    this.filesList[j].isUploaded = true;
                  }
                }

              }

          } else {
            files.push(this.filesList[numIndex].file);
          }

        }
      } catch (e) {
        console.log('ERROR: ' + e);
        this.filesList[index].isProcess = false;
      }
    }
  }

}
